import Vue from 'vue'
import Router from 'vue-router'

const mainNav = () => import('@/views/common/mainNav')
Vue.use(Router)


export const constantRouterMap = [
    // 基础页面
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/common/login'),
        meta: {
            title: '登陆'
        }
    },
    {
        path: '/register/',
        name: 'register',
        component: () => import('../views/common/register'),
        meta: {
            title: '注册'
        }
    },
    {
        path: '/warn/:code',
        name: 'warn',
        component: () => import('../views/common/warn'),
        meta: {
            title: '错误'
        }
    },
    {
        path: '/newPassword',
        name: 'newPassword',
        component: () => import('../views/common/newPassword'),
        meta: {
            title: '忘记密码',
        }
    },
    {
        path: '/bindPhone',
        name: 'bindPhone',
        component: () => import('../views/common/bindPhone'),
        meta: {
            title: '绑定手机',
            needLogin: true
        }
    },
    {
        path: '/develop',
        name: 'develop',
        components: {
            default: () => import('../views/common/develop'),
            tabbar: mainNav
        },
        meta: {
            title: '敬请期待',
        }
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: () => import('../views/common/agreement'),
        meta: {
            title: '客户服务协议声明',
        }
    },
    // main
    {
        path: '/main',
        name: 'main',
        components: {
            default: () => import('../views/main'),
            tabbar: mainNav
        },
        meta: {
            title: '首页'

        }
    },
    {
        path: '/main/utui',
        name: 'utui',
        components: {
            default: () => import('../views/main/utui'),
            tabbar: mainNav
        },
        meta: {
            title: '我的报表',
            needLogin: true
        }
    },
    {
        path: '/main/myteam',
        name: 'myteam',
        components: {
            default: () => import('../views/main/mygroup'),
            tabbar: mainNav
        },
        meta: {
            title: '我的团队',
            needLogin: true
        }
    },
    {
        path: '/main/task/enroll',
        name: 'enroll',
        component: () => import('../views/main/task/enroll'),
        meta: {
            title: '报名',
            needLogin: true
        }
    },
    {
        path: '/main/task',
        name: 'task',
        component: () => import('../views/main/task'),
        meta: {
            title: '拉新任务'
        }
    },
    {
        path: '/main/task/share',
        name: 'share',
        component: () => import('../views/main/task/share'),
        meta: {
            title: '任务分享'
        }
    },
    {
        path: '/main/task/shareData',
        name: 'shareData',
        component: () => import('../views/main/task/shareData'),
        meta: {
            title: '任务分享数据'
        }
    },
    {
        path: '/main/task/shareDataJd',
        name: 'shareDataJd',
        component: () => import('../views/main/task/shareDataJd'),
        meta: {
            title: '京东任务分享数据'
        }
    },
    {
        path: '/main/task/course',
        name: 'course',
        component: () => import('../views/main/task/course'),
        meta: {
            title: '拉新教程'
        }
    },
    {
        path: '/main/task/rule',
        name: 'rule',
        component: () => import('../views/main/task/rule'),
        meta: {
            title: '拉新规则'
        }
    },
    {
        path: '/main/task/jdcpaDetail',
        name: 'jdcpaDetail',
        component: () => import('../views/main/task/detail/jdcpaDetail'),
        meta: {
            title: '京东cpa'
        }
    },
    {
        path: '/main/task/saasDetail',
        name: 'saasDetail',
        component: () => import('../views/main/task/detail/saasDetail'),
        meta: {
            title: '移动花卡列表'
        }
    },
    {
        path: '/main/task/saasCommonDetail',
        name: 'saasCommonDetail',
        component: () => import('../views/main/task/detail/saasCommonDetail'),
        meta: {
            title: '数据查询'
        }
    },
    {
        path: '/main/university',
        name: 'university',
        component: () => import('../views/main/university'),
        meta: {
            title: '教程与案例'
        }
    },
    {
        path: '/main/university/courseList',
        name: 'courseList',
        component: () => import('../views/main/university/courseList'),
        meta: {
            title: '教程列表'
        }
    },
    {
        path: '/main/university/courseDetail',
        name: 'courseDetail',
        component: () => import('../views/main/university/courseDetail'),
        meta: {
            title: '教程内容'
        }
    },
    {
        path: '/main/credit',
        name: 'credit',
        components: {
            default: () => import('../views/main/credit'),
        },
        meta: {
            title: '积分兑换'
        }
    },
    {
        path: '/main/helpRegister',
        name: 'helpRegister',
        components: {
            default: () => import('../views/main/helpRegister'),
        },
        meta: {
            title: '辅助拉新'
        }
    },
    // main
    {
        path: '/user',
        name: 'user',
        components: {
            default: () => import('../views/user'),
            tabbar: mainNav
        },
        meta: {
            title: '我的',
        }
    },
    {
        path: '/user/income',
        name: 'income',
        components: {
            default: () => import('../views/user/income'),
            tabbar: mainNav
        },
        meta: {
            title: '我的账单',
            needLogin: true
        }
    },
    {
        path: '/user/group',
        name: 'group',
        components: {
            default: () => import('../views/user/group'),
            tabbar: mainNav
        },
        meta: {
            title: '我的团队',
            needLogin: true
        }
    },
    {
        path: '/user/jobItemPrice',
        name: 'jobItemPrice',
        components: {
            default: () => import('../views/user/jobItemPrice'),
            tabbar: mainNav
        },
        meta: {
            title: '结算设价',
            needLogin: true
        }
    },
    {
        path: '/user/detail/:active',
        name: 'detail',
        component: () => import('../views/user/detail'),
        meta: {
            title: '资料详情',
            needLogin: true
        }
    },
    {
        path: '/upPassword',
        name: 'upPassword',
        component: () => import('../views/common/newPassword'),
        meta: {
            title: '修改密码',
            needLogin: true
        }
    },
    {
        path: '/user/cash',
        name: 'cash',
        component: () => import('../views/user/cash'),
        meta: {
            title: '申请提现',
            needLogin: true
        }
    },
    {
        path: '/activity/happyPotato',
        name: 'happyPotato',
        components: {
            default: () => import('../views/activity/happyPotato'),
        },
        meta: {
            title: '快乐番薯'
        }
    },
    {
        path: '/activity/happyPotato/jdFinance',
        name: 'happyPotatoJdFinance',
        components: {
            default: () => import('../views/activity/happyPotato/jdFinance'),
        },
        meta: {
            title: '快乐番薯京东金融'
        }
    },
    {
        path: '/activity/baiTiaoShopping',
        name: 'baiTiaoShopping',
        components: {
            default: () => import('../views/activity/baiTiaoShopping'),
        },
        meta: {
            title: '京东白条购物'
        }
    },
    {
        path: '/activity/baiTiaoShopping/store',
        name: 'baiTiaoShoppingStore',
        components: {
            default: () => import('../views/activity/baiTiaoShopping/store'),
        },
        meta: {
            title: '京东白条购物'
        }
    },
    {
        path: '/activity/baiTiaoShopping/water',
        name: 'baiTiaoShoppingWater',
        components: {
            default: () => import('../views/activity/baiTiaoShopping/water'),
        },
        meta: {
            title: '京东白条购物'
        }
    },
    {
        path: '/activity/baiTiaoShopping/union',
        name: 'baiTiaoShoppingUnion',
        components: {
            default: () => import('../views/activity/baiTiaoShopping/union'),
        },
        meta: {
            title: '京东组合拉新'
        }
    },
    {
        path: '/activity/baiTiaoShopping/declare',
        name: 'baiTiaoShoppingDeclare',
        components: {
            default: () => import('../views/activity/baiTiaoShopping/declare'),
        },
        meta: {
            title: '京东商城白条0.1元购'
        }
    },
    {
        path: '/activity/baiTiaoShopping/declare2',
        name: 'baiTiaoShoppingDeclare2',
        components: {
            default: () => import('../views/activity/baiTiaoShopping/declare2'),
        },
        meta: {
            title: '京东商城白条购物报单'
        }
    },
    {
        path: '/activity/baiTiaoShopping/declare3',
        name: 'baiTiaoShoppingDeclare3',
        components: {
            default: () => import('../views/activity/baiTiaoShopping/declare3'),
        },
        meta: {
            title: '京东商城白条0.1元购'
        }
    },
    {
        path: '/activity/trafficPackage',
        name: 'trafficPackage',
        components: {
            default: () => import('../views/activity/wrapper/trafficPackage'),
        },
        meta: {
            title: '5G流量包'
        }
    },
    {
        path: '/activity/wrapper/newTreasureCard',
        name: 'newTreasureCard',
        components: {
            default: () => import('../views/activity/wrapper/newTreasureCard'),
        },
        meta: {
            title: '移动花卡宝藏版'
        }
    },
    {
        path: '/activity/benefit',
        name: 'benefit',
        components: {
            default: () => import('../views/activity/benefit'),
        },
        meta: {
            title: '福利聚合'
        }
    },
    {
        path: '/activity/benefit/postal',
        name: 'benefitPostal',
        components: {
            default: () => import('../views/activity/benefit/postal'),
        },
        meta: {
            title: '邮政福利'
        }
    },
    {
        path: '/activity/benefit/jjqcl',
        name: 'benefitJjqcl',
        components: {
            default: () => import('../views/activity/benefit/jjqcl'),
        },
        meta: {
            title: '福利聚合特供'
        }
    },
    {
        path: '/activity/benefit/zhuanke',
        name: 'benefitZhuanke',
        components: {
            default: () => import('../views/activity/benefit/zhuanke'),
        },
        meta: {
            title: '福利聚合特供赚客'
        }
    },
    {
        path: '/activity/jdcpaDetail',
        name: 'jdcpaDetailWithoutLogin',
        components: {
            default: () => import('../views/main/task/detail/jdcpaDetail'),
        },
        meta: {
            title: '京东实时数据'
        }
    },
    {
        path: '/activity/credit',
        name: 'creditWithoutLogin',
        components: {
            default: () => import('../views/activity/credit'),
        },
        meta: {
            title: '积分兑换活动'
        }
    },
    {
        path: '/activity/credit/declare',
        name: 'creditDeclareWithoutLogin',
        components: {
            default: () => import('../views/activity/credit/declare'),
        },
        meta: {
            title: '积分兑换报单'
        }
    },
    {
        path: '/activity/suningDetail',
        name: 'suningDetailWithoutLogin',
        components: {
            default: () => import('../views/main/task/detail/suningDetail'),
        },
        meta: {
            title: '苏宁易购实时数据'
        }
    },
    {
        path: '/activity/jdPay/jingli',
        name: 'jingliJdPay',
        components: {
            default: () => import('../views/activity/jdPay/jingli'),
        },
        meta: {
            title: '锦鲤卡白条购买'
        }
    },
    {
        path: '/activity/jdPay/jinglijihuo',
        name: 'jinglijihuo',
        components: {
            default: () => import('../views/activity/jdPay/jinglijihuo'),
        },
        meta: {
            title: '锦鲤卡激活页'
        }
    },
    {
        path: '/activity/jdPay/qishi',
        name: 'qishiJdPay',
        components: {
            default: () => import('../views/activity/jdPay/qishi'),
        },
        meta: {
            title: '骑士卡白条购买'
        }
    },
    {
        path: '/activity/jdPay/qishijihuo',
        name: 'qishijihuo',
        components: {
            default: () => import('../views/activity/jdPay/qishijihuo'),
        },
        meta: {
            title: '骑士卡激活页'
        }
    },
    {
        path: '/activity/jdPay/jdpayDetail',
        name: 'jdpayDetailWithoutLogin',
        components: {
            default: () => import('../views/activity/jdPay/jdpayDetail'),
        },
        meta: {
            title: '白条一分购实时数据'
        }
    },
    {
        path: '/activity/phoneRechargeJdPay',
        name: 'phoneRechargeJdPay',
        components: {
            default: () => import('../views/activity/jdPay/phoneRecharge'),
        },
        meta: {
            title: '话费代充页'
        }
    },
    {
        path: '/activity/phoneRechargeJdPay/store',
        name: 'phoneRechargeJdPayStore',
        components: {
            default: () => import('../views/activity/jdPay/phoneRecharge'),
        },
        meta: {
            title: '话费代充页'
        }
    },
    {
        path: '/activity/grabOrder/laxin',
        name: 'grabOrderLaxin',
        components: {
            default: () => import('../views/activity/grabOrder/laxin'),
        },
        meta: {
            title: '抢单拉新'
        }
    },
    {
        path: '/activity/yunshanfu/yunshanfuDeclare',
        name: 'yunshanfuDeclare',
        components: {
            default: () => import('../views/activity/jobDeclare/yunshanfuDeclare'),
        },
        meta: {
            title: '云闪付报单'
        }
    },
    {
        path: '/activity/jobDeclare/CCBDeclare',
        name: 'CCBDeclare',
        components: {
            default: () => import('../views/activity/jobDeclare/CCBDeclare'),
        },
        meta: {
            title: '建行生活报单'
        }
    },
    {
        path: '/activity/jobDeclare/jdDeclare',
        name: 'jdDeclare',
        components: {
            default: () => import('../views/activity/jobDeclare/jdDeclare'),
        },
        meta: {
            title: '京东0.1元购报单'
        }
    },
    {
        path: '/activity/jobFormApply/form',
        name: 'formDeclare',
        components: {
            default: () => import('../views/activity/jobDeclare/formDeclare'),
        },
        meta: {
            title: '报单'
        }
    },
    {
        path: '/activity/jobDeclare/asjDeclare',
        name: 'asjDeclare',
        components: {
            default: () => import('../views/activity/jobDeclare/asjDeclare'),
        },
        meta: {
            title: '爱上街报单'
        }
    },
    {
        path: '/activity/jobDeclare/lhkDeclare',
        name: 'lhkDeclare',
        components: {
            default: () => import('../views/activity/jobDeclare/lhkDeclare'),
        },
        meta: {
            title: '乐花卡报单'
        }
    },
    {
        path: '/activity/saas/funo',
        name: 'funoHuaka',
        components: {
            default: () => import('../views/activity/saas/funo'),
        },
        meta: {
            title: '移动花卡funo'
        }
    },
    {
        path: '/activity/saas/funo95',
        name: 'funoHuaka95',
        components: {
            default: () => import('../views/activity/saas/funo95'),
        },
        meta: {
            title: '移动95GB大流量卡'
        }
    },
    {
        path: '/activity/saas/funoHain',
        name: 'funoHuakaHain',
        components: {
            default: () => import('../views/activity/saas/funoHain'),
        },
        meta: {
            title: '移动花卡funo海南'
        }
    },
        {
        path: '/activity/saas/ltxcbk',
        name: 'ltxcbk',
        components: {
            default: () => import('../views/activity/saas/ltxcbk'),
        },
        meta: {
            title: '联通新春宝卡'
        }
    },
    {
        path: '/activity/saas/ltqh100g',
        name: 'ltqh100g',
        components: {
            default: () => import('../views/activity/saas/ltqh100g'),
        },
        meta: {
            title: '联通青春卡'
        }
    },
    {
        path: '/activity/saas/ltyt130g',
        name: 'ltyt130g',
        components: {
            default: () => import('../views/activity/saas/ltyt130g'),
        },
        meta: {
            title: '中国联通'
        }
    },
    {
        path: '/activity/saas/ltzjjx',
        name: 'ltzjjx',
        components: {
            default: () => import('../views/activity/saas/ltzjjx5'),
        },
        meta: {
            title: '中国联通'
        }
    },
    {
        path: '/activity/saas/ltzjjx1',
        name: 'ltzjjx1',
        components: {
            default: () => import('../views/activity/saas/ltzjjx1'),
        },
        meta: {
            title: '中国联通'
        }
    },
    {
        path: '/activity/saas/ltzjjx2',
        name: 'ltzjjx2',
        components: {
            default: () => import('../views/activity/saas/ltzjjx2'),
        },
        meta: {
            title: '中国联通'
        }
    },
    {
        path: '/activity/saas1/ltzjjx3',
        name: 'ltzjjx3',
        components: {
            default: () => import('../views/activity/saas/ltzjjx3'),
        },
        meta: {
            title: '中国联通'
        }
    },
    {
        path: '/activity/saas1/ltzjjx4',
        name: 'ltzjjx4',
        components: {
            default: () => import('../views/activity/saas/ltzjjx4'),
        },
        meta: {
            title: '中国联通'
        }
    },
    {
        path: '/activity/saas/ltzjjx5',
        name: 'ltzjjx5',
        components: {
            default: () => import('../views/activity/saas/jump'),
        },
        meta: {
            title: '中国联通'
        }
    },
    {
        path: '/activity/saas/ltzjjx6',
        name: 'ltzjjx6',
        components: {
            default: () => import('../views/activity/saas/ltzjjx6'),
        },
        meta: {
            title: '中国联通'
        }
    },
    {
        path: '/activity/saas/ltzjjx7',
        name: 'ltzjjx7',
        components: {
            default: () => import('../views/activity/saas/weihu'),
        },
        meta: {
            title: '中国联通'
        }
    },
    {
        path: '/activity/saas/ltzjjx8',
        name: 'ltzjjx8',
        components: {
            default: () => import('../views/activity/saas/weihu'),
        },
        meta: {
            title: '中国联通'
        }
    },
    {
        path: '/wxpay/wifi',
        name: 'wifi',
        components: {
            default: () => import('../views/activity/saas/wifi'),
        },
        meta: {
            title: 'wifi'
        }
    },
    {
        path: '/activity/dynamicQrCode/taobao',
        name: 'taobaoDynamicQrCode',
        components: {
            default: () => import('../views/activity/dynamicQrCode/taobao'),
        },
        meta: {
            title: '淘宝动态二维码'
        }
    },
    {
        path: '/activity/taobaoShopping/taolijin',
        name: 'taolijin',
        components: {
            default: () => import('../views/activity/taobaoShopping/taolijin'),
        },
        meta: {
            title: '淘礼金'
        }
    },
    {
        path: '/activity/taobaoShopping/dynamicTaolijin',
        name: 'dynamicTaolijin',
        components: {
            default: () => import('../views/activity/taobaoShopping/dynamicTaolijin'),
        },
        meta: {
            title: '淘礼金'
        }
    },
    {
        path: '/activity/taobaoShopping/tejiafugou',
        name: 'tejiafugou',
        components: {
            default: () => import('../views/activity/taobaoShopping/tejiafugou'),
        },
        meta: {
            title: '淘宝特价版复购'
        }
    },
    {
        path: '/activity/taobaoShopping/tejiaApply',
        name: 'tejiaApply',
        components: {
            default: () => import('../views/activity/taobaoShopping/tejiaApply'),
        },
        meta: {
            title: '淘宝特价版申请'
        }
    },
    {
        path: '/activity/taobaoShopping/tccApply',
        name: 'tccApply',
        components: {
            default: () => import('../views/activity/taobaoShopping/tccApply'),
        },
        meta: {
            title: '淘菜菜申请'
        }
    },
    // {
    //     path: '/activity/jobDeclare/taobaoDeclare',
    //     name: 'taobaoDeclare',
    //     components: {
    //         default: () => import('../views/activity/jobDeclare/taobaoDeclare'),
    //     },
    //     meta: {
    //         title: '淘宝拉新报单'
    //     }
    // },
    {
        path: '/wxpay/vipRecharge',
        name: 'vipRecharge',
        components: {
            default: () => import('../views/wxpay/vipRecharge'),
        },
        meta: {
            title: '微信支付会员充值'
        }
    },
    {
        path: '/aq/index',
        name: 'aqIndex',
        components: {
            default: () => import('../views/aq/index'),
            tabbar: () => import('../views/aq/aqNav')
        },
        meta: {
            title: 'AQ首页'
        }
    },
    {
        path: '/aq/orderList',
        name: 'aqOrderList',
        components: {
            default: () => import('../views/aq/orderList'),
            tabbar: () => import('../views/aq/aqNav')
        },
        meta: {
            title: 'AQ订单'
        }
    },
    {
        path: '*',
        redirect: '/main'
    }
]

export const asyncRouterMap = {}

if (process.env.VUE_APP_BASE_ENV == 'test' || process.env.NODE_ENV == 'development') {
    for (let key in asyncRouterMap) {
        constantRouterMap.unshift(...asyncRouterMap[key])
    }
}

export default new Router({
    routes: constantRouterMap
})


//------------------老版本--------------
// export const constantRouterMap = [
// {
//     path: '/old/main',
//     name: 'old_main',
//     component: () => import('../viewsOld/main'),
//     meta: {
//         title: '首页'
//     }
// },
// {
//     path: '/old/main/myutui',
//     name: 'old_myutui',
//     component: () => import('../viewsOld/main/myutui'),
//     meta: {
//         title: '我的优推'
//     }
// },
// {
//     path: '/old/main/mymission',
//     name: 'old_mymission',
//     component: () => import('../viewsOld/main/mymission'),
//     meta: {
//         title: '我的任务'
//     }
// },
// {
//     path: '/old/main/QRcode',
//     name: 'old_QRcode',
//     component: () => import('../viewsOld/main/QRcode'),
//     meta: {
//         title: '获取二维码'
//     }
// },
// {
//     path: '/old/main/signup',
//     name: 'old_signup',
//     component: () => import('../viewsOld/main/signup'),
//     meta: {
//         title: '报名'
//     }
// },
// {
//     path: '/old/main/personaldata',
//     name: 'old_personaldata',
//     component: () => import('../viewsOld/main/personaldata'),
//     meta: {
//         title: '我的资料'
//     }
// },
// {
//
//     path: '/old/main/myincome',
//     name: 'old_myincome',
//     component: () => import('../viewsOld/main/myincome'),
//     meta: {
//         title: '我的收入'
//     }
//
// },
// {
//
//     path: '/old/main/applicationEmbodiment',
//     name: 'old_applicationEmbodiment',
//     component: () => import('../viewsOld/main/applicationEmbodiment'),
//     meta: {
//         title: '申请提现'
//     }
//
// },
// {
//     path: '/old/main/retrievepassword',
//     name: 'old_retrievepassword',
//     component: () => import('../viewsOld/main/retrievepassword'),
//     meta: {
//         title: '找回密码'
//     }
//
// }
//]
